import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from "@angular/common/http";
import { Auth0Service } from "src/app/authentication/auth0/auth0.service";
import { environment } from '../../../environments/environment';
import { throwError } from 'rxjs';
import { LoaderService } from './loader.service';
import { catchError } from 'rxjs/operators';
@Injectable()
export class HttpService {

  constructor(
    private http: HttpClient,
    private auth0: Auth0Service,
    private loader: LoaderService
  ) {
    if(this.auth0.accessToken){
      this.accessToken = this.auth0.accessToken;
    }else if(JSON.parse(localStorage.getItem('tokenInfo'))){
      this.accessToken = JSON.parse(localStorage.getItem('tokenInfo')).accessToken
    }
    this.header = new HttpHeaders().set('Authorization', `Bearer ${this.accessToken}`)
  }

  baseUrl = environment.baseUrl;
  accessToken: string
  header: HttpHeaders
  
  post(endpoint, data) {
    let url = getUrl(endpoint);
    return this.http.post(url, data, { headers: this.header })
    .pipe(catchError(this.handleError))
  }

  get(endpoint) {
    let url = getUrl(endpoint);
    return this.http.get(url, { headers: this.header })
    .pipe(catchError(this.handleError))
  }

  put(endpoint, data) {
    let url = getUrl(endpoint);
    return this.http.put(url, data, { headers: this.header })
    .pipe(catchError(this.handleError))
  }

  delete(endpoint) {
    let url = getUrl(endpoint);
    return this.http.delete(url, { headers: this.header })
    .pipe(catchError(this.handleError))
  }

  get_landing_page(endpoint) {
    let url = getUrl(endpoint);
    return this.http.get(url, { headers: this.header })
    .pipe(catchError(this.handleError))
  }

handleError = (errorResponse: HttpErrorResponse) => {
  this.loader.hide('progress');
  console.log("errorRes", errorResponse)
    if(errorResponse.status === 401 || errorResponse.status === 403) {
      this.auth0.logout()
    }else if(errorResponse.status === 400 || errorResponse.status === 500) {
      this.loader.hide('progress');
      return throwError(errorResponse.error.error || errorResponse.error || "Something went wrong");
    }else if(errorResponse.status === 404){
      this.loader.hide('progress');
      console.log("server side error", errorResponse.error)
      return throwError(errorResponse.error.message || "Server side error");
    }else if(errorResponse.status === 0){
      return throwError('Seems we are facing some issues with the system, please try after some time');
    }
    else if(errorResponse.error instanceof ErrorEvent){
      this.loader.hide('progress');
      console.log("client side error", errorResponse.error.message)
      return throwError(errorResponse.error.message || "Client side error");
    }else{
      return throwError("Something went wrong");
    }
  }
}

function getUrl(endpoint){
  let type = endpoint.split('?')[0];
  type = type.split('/')[0];
  return environment.baseUrl[type] + endpoint;
}